/* ============================================================
   Section: FC Review Hero
   File:    assets/section-fc-review-hero.js

   1. The section's "Leave a review" button opens Judge.me's form by clicking
      Judge.me's own button (hidden by the section CSS), so Judge.me keeps
      handling the review, verification and moderation.
   2. Auto-open: /pages/review?review=1 (or #review) opens the form on load.
      The word is the section's "Link word" setting.

   Judge.me renders its widget with its own script, sometimes after this one
   runs, so both paths wait for its button to appear before clicking.
   ============================================================ */

(function () {
  'use strict';

  // New widget first, legacy widget as a fallback.
  var JUDGEME_BUTTON = '.jdgm-widget .jm-action-buttons__button, .jdgm-widget .jdgm-write-rev-link';
  var WAIT_MS = 20000;

  function findJudgemeButton() {
    return document.querySelector(JUDGEME_BUTTON);
  }

  function whenJudgemeReady(callback) {
    var btn = findJudgemeButton();
    if (btn) { callback(btn); return; }

    var done = false;
    var observer = new MutationObserver(function () {
      var found = findJudgemeButton();
      if (found && !done) {
        done = true;
        observer.disconnect();
        callback(found);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      if (!done) { done = true; observer.disconnect(); }
    }, WAIT_MS);
  }

  function formIsOpen() {
    var modal = document.querySelector('.jdgm-write-review-modal');
    return !!modal && getComputedStyle(modal).display !== 'none';
  }

  // Judge.me's button is in the page before its script wires it up, and a
  // click before then is silently ignored. So click, check the form actually
  // opened, and try again every half second until it does.
  function openForm() {
    whenJudgemeReady(function (btn) {
      var started = Date.now();
      (function attempt() {
        if (formIsOpen()) return;
        (findJudgemeButton() || btn).click();
        setTimeout(function () {
          if (!formIsOpen() && Date.now() - started < WAIT_MS) attempt();
        }, 500);
      })();
    });
  }

  function wantsAutoOpen(word) {
    if (!word) return false;
    var params = new URLSearchParams(window.location.search);
    if (params.has(word) && params.get(word) !== '0' && params.get(word) !== 'false') return true;
    return window.location.hash.replace('#', '') === word;
  }

  // Drop the trigger from the address bar once used, so a refresh or the
  // Back button doesn't pop the form open again. Other params (UTMs) stay.
  function clearAutoOpen(word) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(word);
      if (url.hash.replace('#', '') === word) url.hash = '';
      history.replaceState(history.state, '', url.toString());
    } catch (e) { /* old browser — leave the URL alone */ }
  }

  // Tap handling: the theme defers its scripts to the first touch, and that
  // first tap can be swallowed (see fc-first-tap-fix.js). Act on pointerup for
  // touch and skip the click the browser synthesizes after it; mouse and
  // keyboard keep using click.
  function bindButton(button) {
    var swallowClick = false;
    var startX = 0, startY = 0;

    button.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY;
    });
    button.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') return;
      if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) return;
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 600);
      openForm();
    });
    button.addEventListener('click', function (e) {
      if (swallowClick) { swallowClick = false; e.preventDefault(); return; }
      openForm();
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-fc-review-hero]');
    var autoWord = '';

    sections.forEach(function (section) {
      section.querySelectorAll('[data-fc-review-open]').forEach(bindButton);
      if (!autoWord) autoWord = (section.getAttribute('data-auto-open-param') || '').trim();
    });

    if (wantsAutoOpen(autoWord)) {
      clearAutoOpen(autoWord);
      openForm();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
